/**
 * وضعیتِ اعلانِ همین مرورگر، بعد از این که یک بار «بله» گفته شد — فقط در
 * تنظیماتِ اعلان.
 *
 * ═══ چرا جدا از PushOfferCard ═══
 *
 * آن کارت «پیشنهاد» است و با `granted` شدن برای همیشه ناپدید می‌شود — که
 * برای Discover درست است، ولی در تنظیمات یعنی راهِ خاموش کردن وجود ندارد.
 * و خاموش کردن باید واقعی باشد: حذفِ توکن از `push_tokens`، نه فقط یک
 * سوییچِ ظاهری (نگاه کن به disableWebPush).
 *
 * ═══ چرا بعد از خاموش کردن، دکمه‌ی روشن کردن همین‌جاست ═══
 *
 * اجازه‌ی مرورگر `granted` می‌ماند، پس `shouldOfferPush` دیگر هرگز کارتِ
 * پیشنهاد را نمی‌آورد — بدونِ این دکمه، «خاموش کردم، پشیمان شدم» بن‌بست
 * بود. روشن کردنِ دوباره پنجره‌ای باز نمی‌کند: اجازه از قبل هست و
 * `requestPermission` بی‌درنگ همان `granted` را برمی‌گرداند.
 */
import React from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useSession } from '@/core/session';
import { t, useLocale } from '@/core/lib/i18n';
import { Card } from '@/ui/kit';
import { disableWebPush, enableWebPush, pushConfigured, pushPermission, webPushActive } from './webPush';

export function PushManageCard() {
  useLocale();
  const { profile } = useSession();
  const [busy, setBusy] = React.useState(false);
  const qc = useQueryClient();

  const granted = pushConfigured() && pushPermission() === 'granted';
  const active = useQuery({
    queryKey: ['webPushActive'],
    queryFn: webPushActive,
    enabled: !!profile && granted,
  });

  // تا اجازه‌ای نباشد چیزی برای مدیریت نیست؛ پیشنهادش کارِ PushOfferCard است.
  if (!profile || !granted || active.data === undefined) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      if (active.data) await disableWebPush();
      else await enableWebPush(profile.id);
      await qc.invalidateQueries({ queryKey: ['webPushActive'] });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card>
      <h3>{t(active.data ? 'pushWebOn' : 'pushWebOff')}</h3>
      <div className="chiprow chips-wrap">
        <button type="button" className="btn" disabled={busy} onClick={toggle}>
          {busy ? '…' : t(active.data ? 'pushWebTurnOff' : 'pushWebEnable')}
        </button>
      </div>
    </Card>
  );
}
